import { render, staticRenderFns } from "./tabs_with_list.vue.js?vue&type=template&id=80b28aae&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=template&id=80b28aae&vue3"
import script from "./tabs_with_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=script&lang=js&vue3"
export * from "./tabs_with_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports